import { format } from "date-fns";

const IST = "Asia/Kolkata";

/** Parse API values; ISO datetimes without a timezone are treated as UTC. */
export function parseApiDate(value) {
  if (value == null || value === "") return null;
  if (value instanceof Date) {
    return Number.isFinite(value.getTime()) ? value : null;
  }
  const s = String(value).trim();
  if (!s) return null;
  const isBareIso =
    /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(s) &&
    !/[zZ]$/.test(s) &&
    !/[+-]\d{2}:?\d{2}$/.test(s);
  const d = new Date(isBareIso ? `${s}Z` : s);
  return Number.isFinite(d.getTime()) ? d : null;
}

/** Timeline display — same pattern as `formatDateTimeShort`, always IST. */
export function formatDateTimeShortIst(value) {
  const d = parseApiDate(value);
  if (!d) return value == null || value === "" ? "-" : String(value);

  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: IST,
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  }).formatToParts(d);

  const pick = (type) => parts.find((p) => p.type === type)?.value ?? "";
  return `${pick("month")} ${pick("day")}, ${pick("year")} • ${pick("hour")}:${pick("minute")} ${pick("dayPeriod")}`;
}

export function formatDateTimeShort(value) {
  const d = parseApiDate(value);
  return d ? format(d, "MMM dd, yyyy • hh:mm a") : value == null || value === "" ? "-" : String(value);
}
